import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

export const onRecentWorkLinkClick: (props: commonAttributesType) => AnalyticsEventPayload = (
	props: commonAttributesType,
): AnalyticsEventPayload => {
	const { query, answerString, source } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerRecentWorkListLink',
		source,
		eventType: 'ui',
		attributes: {
			...filterCommonAttributes(props),
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
